//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import newApi from '@/utils/newModuleApi'

export default {
  data () {
    return {
      data: { categories: [] },
      detailShow: false,
      currentBadge: null
    }
  },
  created () {
    this.$ajax.get(newApi.achievementList).then(res => { this.data = res || { categories: [] } }).catch(() => {})
  },
  methods: {
    openDetail (badge) {
      this.currentBadge = badge
      this.detailShow = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/new/achievement/list.vue